import React, { useState, useEffect } from 'react';
import { Menu, X, Plane } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/90 backdrop-blur-lg shadow-md'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://customer-assets.emergentagent.com/job_5112f21d-d025-4b4a-bf6b-cb6ce4d15052/artifacts/hq70snir_VBK%20LOGO.png" 
              alt="Vacay with K Logo" 
              className="h-12 w-12 object-contain"
            />
            <span className={`text-2xl font-bold brand-title ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}>
              Vacay with K
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('destinations')}
              className={`font-medium transition-colors hover:text-[#ef571b] ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Destinations
            </button>
            <button
              onClick={() => scrollToSection('packages')}
              className={`font-medium transition-colors hover:text-[#ef571b] ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Packages
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`font-medium transition-colors hover:text-[#ef571b] ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              About
            </button>
            <a
              href="/blog"
              className={`font-medium transition-colors hover:text-[#ef571b] ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Blog
            </a>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#ef571b] hover:bg-[#d84915] text-white shadow-lg"
            >
              Book Now
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className={`h-6 w-6 ${isScrolled ? 'text-gray-900' : 'text-white'}`} />
            ) : (
              <Menu className={`h-6 w-6 ${isScrolled ? 'text-gray-900' : 'text-white'}`} />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 bg-white/95 backdrop-blur-lg rounded-lg mt-2 shadow-xl">
            <nav className="flex flex-col space-y-4 px-4">
              <button
                onClick={() => scrollToSection('destinations')}
                className="text-gray-700 font-medium hover:text-[#ef571b] transition-colors text-left"
              >
                Destinations
              </button>
              <button
                onClick={() => scrollToSection('packages')}
                className="text-gray-700 font-medium hover:text-[#ef571b] transition-colors text-left"
              >
                Packages
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="text-gray-700 font-medium hover:text-[#ef571b] transition-colors text-left"
              >
                About
              </button>
              <a
                href="/blog"
                className="text-gray-700 font-medium hover:text-[#ef571b] transition-colors text-left"
              >
                Blog
              </a>
              <Button
                onClick={() => scrollToSection('contact')}
                className="bg-[#ef571b] hover:bg-[#d84915] text-white"
              >
                Book Now
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;